export default store => {
  return {
    path: "organizationManagement",
    getComponent(nextState, cb) {
      // require.ensure([],require => {
      const comp = require("./OrganizationManagementRoot").default;
      cb(null, comp);
      // },"administrator-tooling");
    },
  };
};
